export enum FAVORTIES {
    /**
     * @value No favorites
     * @description Message displayed when a directory has no entries
     */
    NO_ENTRIES = 'FRONT.FAVORITES.NO_ENTRIES',
}
